import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    loading: 'ABI loading',
    switchToCustom: 'Switch to custom ABI',
    refetch: 'Refetch ABI',
    customLabel: 'Custom ABI',
    invalidABI: 'ABI is not valid',
    loaded: 'ABI fetched',
    custom: 'Custom Conditions Contract',
    error: 'ABI fetching error',
  },
};
